import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { CustomProvider } from "rsuite";
import { SelectPicker } from "rsuite";
import deDE from "rsuite/locales/de_DE";
import SpinnerIcon from "@rsuite/icons/legacy/Spinner";

import "./TreeSearchStyle.css";

const TreeSearch = ({ roomsForFiltering }) => {
  const [rooms, setRooms] = useState([]);

  let navigate = useNavigate();

  /* React hook that will be executed on creation and every time the dependencies update. */
  useEffect(() => {
    if (rooms.length === 0) {
      setRooms(roomsForFiltering);
    }
  }, [rooms.length, roomsForFiltering]);

  /**
   * Method to be called when values in the picker are updated. Necessary for initiation and error prevention.
   */
  const updateRooms = () => {
    if (rooms.length === 0) {
      setRooms(roomsForFiltering);
    }
  };

  /**
   * Method that is called when the menu should open.
   * Adds the fallback text to the menu.
   */
  const renderMenu = (menu) => {
    if (rooms.length === 0) {
      return (
        /* Async fallback when no data is loaded, yet. */
        <p className="loading-placeholder">
          <SpinnerIcon spin /> Raumliste lädt ...
        </p>
      );
    }
    return menu;
  };

  /**
   * Method that handles the selection of a list element in the SelectPicker.
   * Will navigate to the details page of the selected room.
   * @param {string} value for the selected element. Usually the selected room's ID.
   */
  const openDetails = (value) => {
    navigate(`/room/${value}`);
  };

  return (
    <div className="Tree-Search-Container">
      {/* SelectPicker with a lot of individual params to handle its behavior. */}
      <CustomProvider locale={deDE}>
        <SelectPicker
          placement="autoVerticalStart"
          data={rooms}
          groupBy="building"
          menuClassName="TreeSearch"
          placeholder="Hörsaal manuell suchen"
          onOpen={updateRooms}
          onSearch={updateRooms}
          onChange={updateRooms}
          onSelect={openDetails}
          renderMenu={renderMenu}
          block={true}
          defaultOpen={false}
        />
      </CustomProvider>
    </div>
  );
};

export default TreeSearch;
